module.exports = __webpack_public_path__ + "static/media/contact_details_icon.29b4d48f.svg";